import { render, staticRenderFns } from "./CampaignSettingsTargeting.vue?vue&type=template&id=27eef32b&scoped=true&"
import script from "./CampaignSettingsTargeting.vue?vue&type=script&lang=js&"
export * from "./CampaignSettingsTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eef32b",
  null
  
)

export default component.exports